/**
 * How the inbox writes times. Pure, so the server (a first guess, in its own
 * time zone) and the browser (the viewer's time zone, as Gmail shows it)
 * format the same way.
 */

function formatTime(date: Date): string {
  return date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** The list's shorthand: bare time today, date before that. */
export function formatReceivedAt(date: Date, now = new Date()): string {
  if (date.toDateString() === now.toDateString()) return formatTime(date);

  const sameYear = date.getFullYear() === now.getFullYear();
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    ...(sameYear ? {} : { year: "numeric" }),
  });
}

/** A message's header: "Today · 11:31" or "24 Sept · 09:05". */
export function formatSentAt(date: Date, now = new Date()): string {
  const sameDay = date.toDateString() === now.toDateString();
  const day = sameDay ? "Today" : formatReceivedAt(date, now);
  return `${day} · ${formatTime(date)}`;
}

/** In full, for a forwarded email's header: "Fri, 25 Sept 2026 at 11:31". */
export function formatFullDate(date: Date): string {
  const day = date.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  return `${day} at ${formatTime(date)}`;
}
